import styled from "styled-components";

export const CardContainer = styled.div`
  background-color: #fff;
  border-radius: 12px;
  padding: 28px;
  height: 100%;
`;
